import { PlaygroundHost } from './PlaygroundHost.ts'
import { isPlaygroundEnabled } from '../config/playground'
import { initBootTelemetry, markBootPhase } from './BootTelemetry'

// The Playground App implementations live here rather than on the production
// root because they reach Firebase through HttpAppApi. See src/app/index.ts.
export {
  PlaygroundAppApi,
  SandboxAppApi,
  setStoredAppRole,
} from '../app/PlaygroundAppApi'

if (typeof globalThis !== 'undefined' && isPlaygroundEnabled()) {
  // Earliest SDK-side boot mark — the toolbar script's own start stamp
  // (window.__RUNDOT_PLAYGROUND_BOOT_START__) is merged by BootTelemetry.
  initBootTelemetry()
  markBootPhase('sdk-init')

  ;(globalThis as any).__RUNDOT_PLAYGROUND_HOST_FACTORY__ = (rundotGameApi: any) => {
    return new PlaygroundHost(rundotGameApi)
  }
}
